/**
 * Shown instead of a module page when the tenant's subscription tier is below the
 * module's minimum. No data request is made behind it, so there is no failed call to
 * "Retry" (the old AI Governance behaviour: a 403 that could never succeed).
 */
import PropTypes from 'prop-types';
import Icon from '../../components/AppIcon';

const TIER_LABELS = { basic: 'Basic', professional: 'Professional', enterprise: 'Enterprise' };

const TierRequiredNotice = ({ moduleName, requiredTier }) => (
  <div className="p-6 flex justify-center">
    <div role="status" className="neumorphic-card p-8 max-w-lg text-center space-y-3">
      <Icon name="Lock" size={32} className="theme-text-secondary mx-auto" />
      <h2 className="text-lg font-semibold theme-text-primary">Upgrade required</h2>
      <p className="text-sm theme-text-secondary">
        <strong>{moduleName}</strong> is available on the{' '}
        <strong>{TIER_LABELS[requiredTier] || requiredTier}</strong> plan or higher. Contact your
        administrator to change your organization&apos;s subscription.
      </p>
    </div>
  </div>
);

TierRequiredNotice.propTypes = {
  moduleName: PropTypes.string.isRequired,
  requiredTier: PropTypes.string.isRequired,
};

export default TierRequiredNotice;
